import React from "react";
import {
  FIXED_SIDEBAR_WIDTH_CLOSED,
  FIXED_SIDEBAR_WIDTH_OPEN,
} from "../../../../utils/constant.utils";

export default function Footer({ isSidebarOpen }) {
  return (
    <div
      style={{
        width: `calc(100% - ${
          isSidebarOpen ? FIXED_SIDEBAR_WIDTH_OPEN : FIXED_SIDEBAR_WIDTH_CLOSED
        }px)`,
      }}
      className={`fixed bottom-0 left-[${
        isSidebarOpen ? FIXED_SIDEBAR_WIDTH_OPEN : FIXED_SIDEBAR_WIDTH_CLOSED
      }px] bg-[#F9F7FF] text-sm p-5 pt-3 pb-3`}
    >
      © Copyright 2025. All rights reserved.
    </div>
  );
}
